/**
 * Delay for a WS-triggered, debounced `invalidateQueries`.
 *
 * A plain fixed debounce collapses a burst *within* one client but does not
 * disperse the herd *across* clients — it aligns it. A `flow_event` broadcast
 * reaches every socket in the org within the same millisecond, so a fixed
 * delay makes every connected client's timer expire together and the whole
 * org's refetch lands as one synchronized burst against a shared connection
 * pool.
 *
 * Randomizing the window over `[windowMs, 2 * windowMs)` spreads those
 * refetches out. The lower bound is preserved, so the debounce guarantee is
 * unchanged: a refetch never lands sooner than `windowMs` after the first
 * event in the window, only later.
 *
 * `random` is an injection seam for tests; it must return `[0, 1)`.
 */
export function invalidationDelayMs(windowMs: number, random: () => number = Math.random): number {
  return windowMs + random() * windowMs;
}
